module.exports = __webpack_public_path__ + "static/media/work-thegfb-tiny.388a886b.jpg";